import React, { useEffect, useState, useContext } from 'react'
import { Navigate } from 'react-router-dom'

import HttpClient from '../../../services/HttpClient'

import AppContext from '../../../contexts/AppContext'
import Modal from '../../../components/Modal/Modal'
import FormErrors from '../../../components/FormErrors/FormErrors'
import Button from '../../../components/Button/Button'

export default function ({ isOpen, onClose }) {
  const { user, setUser } = useContext(AppContext)
  if (!user) {
    return <Navigate to="/entrar" />
  }
  const [isModalOpen, setModalOpen] = useState(false)
  const [name, setName] = useState(user.user_public_name)
  const [errors, setErrors] = useState([])

  const onSubmit = async (event) => {
    event.preventDefault()
    setErrors([])
    let _errors = []
    if (!name) return setErrors(['New name is required'])
    else if (name === user.user_public_name) return setErrors(['Name cannot be the same as your current.'])

    const data = {
      name,
      userId: user._id,
    }

    await HttpClient().post('/api/v1/user/change-name', data)
    onClose()

    setUser({
      ...user,
      name,
    })
  }

  const closeModal = () => {
    onClose()
  }

  useEffect(() => {
    setModalOpen(isOpen)
  }, [isOpen])

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} title="Change name">
      <form className="form" onSubmit={onSubmit}>
        {!!errors.length && <FormErrors errors={errors} />}
        <div className="form__group">
          <label className="form__label">New name</label>
          <input className="form__input" placeholder={name} onChange={(e) => setName(e.target.value)} />

          <Button type="submit">Change</Button>
        </div>
      </form>
    </Modal>
  )
}
